import { match } from 'ts-pattern';

import { textStyles } from '@eluve/components';

type HeadingTag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

/**
 * Calculates the appropriate HTML heading tag and className for a given depth.
 */
export const getHeadingPropsForDepth = (
  depth: number,
): { tag: HeadingTag; className: string } => {
  const tag: HeadingTag = match(depth)
    .with(1, () => 'h1' as const)
    .with(2, () => 'h2' as const)
    .with(3, () => 'h3' as const)
    .with(4, () => 'h4' as const)
    .with(5, () => 'h5' as const)
    .otherwise(() => 'h6' as const);

  const className = match(depth)
    .with(1, 2, 3, (d) =>
      textStyles.heading({
        responsive: true,
        weight: 'semibold',
        color: 'primary',
        size: match(d)
          .with(1, () => 'lg' as const)
          .with(2, () => 'md' as const)
          .otherwise(() => 'sm' as const),
      }),
    )
    .otherwise((d) =>
      textStyles.body({
        responsive: true,
        weight: 'semibold',
        color: 'primary',
        size: match(d)
          .with(4, () => 'lg' as const)
          .with(5, () => 'md' as const)
          .otherwise(() => 'sm' as const),
      }),
    );

  return { tag, className };
};
